var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1980,
    height: 480,
    viewBox: "0 0 1980 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1980,
    height: 480,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.5 207H977C969.999 207 966.499 207 963.825 208.362C961.473 209.561 959.561 211.473 958.362 213.825C957 216.499 957 219.999 957 227V253.667C957 260.667 957 264.167 958.362 266.842C959.561 269.194 961.473 271.106 963.825 272.304C966.499 273.667 969.999 273.667 977 273.667H1003.67C1010.67 273.667 1014.17 273.667 1016.84 272.304C1019.19 271.106 1021.11 269.194 1022.3 266.842C1023.67 264.167 1023.67 260.667 1023.67 253.667V236.167",
    stroke: "#2A76F4",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M957 257L974.887 239.113C976.514 237.486 979.152 237.486 980.78 239.113L994.5 252.833M994.5 252.833L1006.14 241.196C1007.76 239.569 1010.4 239.569 1012.03 241.196L1023.67 252.833M994.5 252.833L1003.87 262.208",
    stroke: "#2A76F4",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.67 228.167V207.333M1014.67 207.333L1006.33 215.667M1014.67 207.333L1023 215.667",
    stroke: "#2A76F4",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBanner);
export default __webpack_public_path__ + "static/media/uploadBanner.e4dcae917002d1bfa5ece6654ce494a8.svg";
export { ForwardRef as ReactComponent };